import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserService } from '@core/services/user/user.service';
import { environment } from 'src/environments/environment';

export const CAMPUS_HEADER = 'X-Campus-Id';

/**
 * Contexto de campus por petición (ADR 0002). El campus actual vive en el usuario del API, uno para
 * todos sus dispositivos: si otro dispositivo (o soporte) lo cambia, este seguiría mandando
 * peticiones armadas para el campus anterior y el API las ejecutaría en el nuevo. Con el campus que
 * este dispositivo cree tener, el API responde 409 `campus_changed` en vez de ejecutarlas, y
 * `errorInterceptor` resincroniza `me` (`AuthService.resyncCampus()`).
 *
 * Sin campus conocido (storage aún no responde, sin sesión) la petición sale sin la cabecera y el
 * API no compara: el mismo comportamiento que antes.
 */
export const campusContextInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.url.includes(environment.apiBaseUrl) || request.headers.has(CAMPUS_HEADER)) {
    return next(request);
  }

  const campusId = inject(UserService).campusId();
  if (campusId == null) {
    return next(request);
  }

  return next(request.clone({ setHeaders: { [CAMPUS_HEADER]: String(campusId) } }));
};
